import { useMutation } from '@tanstack/react-query';
import { POST_LOGIN_DEALER, POST } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useLoginDealer = () =>
  useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_LOGIN_DEALER(), payload);
      return response;
    },
    onSuccess: (data) => {
      openAlert({
        type: 'success',
        model: 'message',
        message: data?.message,
      });
    },
    onError: (error) => {
      openAlert({
        type: 'error',
        model: 'message',
        message: error?.message,
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    },
  });
